[
  [
    {
      "category": "Navegadores famosos",
      "words": [
        "CABRAL",
        "COLOMBO",
        "POLO",
        "MAGALHÃES"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Times de futebol do Rio de Janeiro",
      "words": [
        "FLAMENGO",
        "FLUMINENSE",
        "VASCO DA GAMA",
        "BOTAFOGO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Partes do ovo",
      "words": [
        "CLARA",
        "GEMA",
        "CASCA",
        "MEMBRANA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Ingredientes de bolo",
      "words": [
        "FARINHA",
        "AÇÚCAR",
        "LEITE",
        "FERMENTO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Danças",
      "words": [
        "SAMBA",
        "FORRÓ",
        "QUADRILHA",
        "BOLERO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Que está à margem",
      "words": [
        "MARGINAL",
        "PERIFÉRICO",
        "SECUNDÁRIO",
        "LIMÍTROFE"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Você encontra na delegacia",
      "words": [
        "BANDIDO",
        "POLICIAL",
        "DELEGADO",
        "ALGEMA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Batida",
      "words": [
        "PAULADA",
        "LAMBADA",
        "BORDOADA",
        "CACETADA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Partes da planta",
      "words": [
        "CAULE",
        "FOLHA",
        "SEMENTE",
        "FRUTA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Presentes para namorada",
      "words": [
        "FLOR",
        "BOM-BOM",
        "URSINHO",
        "PERFUME"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Valor a pagar",
      "words": [
        "TAXA",
        "JOIA",
        "IMPOSTO",
        "QUOTA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Adjetivos positivos",
      "words": [
        "BACANA",
        "LEGAL",
        "PERFEITO",
        "ÓTIMO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Patentes da aeronáutica",
      "words": [
        "MAJOR",
        "CORONEL",
        "BRIGADEIRO",
        "CAPITÃO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Tem em festa de aniversário",
      "words": [
        "GUARANÁ",
        "BOLO",
        "SALGADINHO",
        "DOCINHO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Formas litorâneas de relevo",
      "words": [
        "BAÍA",
        "CABO",
        "PENÍNSULA",
        "GOLFO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Que está junto",
      "words": [
        "COLADO",
        "UNIDO",
        "SOLDADO",
        "AGLUTINADO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Máquina de _____",
      "words": [
        "LAVAR",
        "SECAR",
        "CAFÉ",
        "BARBEAR"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Coisas cheias de ar",
      "words": [
        "BOLHA",
        "BOIA",
        "BALÃO",
        "PNEU"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "____ de neve",
      "words": [
        "BONECO",
        "BOLA",
        "BRANCA",
        "TEMPESTADE"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Coisas para lavar",
      "words": [
        "DETERGENTE",
        "SABONETE",
        "SABÃO",
        "XAMPU"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Grandezas físicas",
      "words": [
        "TEMPO",
        "TEMPERATURA",
        "FORÇA",
        "PRESSÃO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Organizações terroristas",
      "words": [
        "ETA",
        "IRA",
        "AL QAEDA",
        "HAMAS"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Sentimentos",
      "words": [
        "AMOR",
        "CIÚME",
        "TRISTEZA",
        "INVEJA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Pratos italianos",
      "words": [
        "MASSA",
        "PIZZA",
        "RISOTTO",
        "BRUSCHETTA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Tem na padaria",
      "words": [
        "PÃO",
        "TORTA",
        "BISCOITO",
        "SONHO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Anseio",
      "words": [
        "DESEJO",
        "ASPIRAÇÃO",
        "AMBIÇÃO",
        "OBJETIVO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Não é real",
      "words": [
        "ILUSÃO",
        "ENGANO",
        "ENGODO",
        "FANTASIA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Coisas do Carnaval",
      "words": [
        "ADEREÇO",
        "SERPENTINA",
        "FOLIA",
        "ALEGORIA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Esquadrão _____",
      "words": [
        "SUICIDA",
        "CLASSE A",
        "NAVAL",
        "DA MODA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Tipos de carro",
      "words": [
        "SUV",
        "PICAPE",
        "SEDAN",
        "MINIVAN"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Espreita",
      "words": [
        "PATRULHA",
        "VIGIA",
        "OLHA",
        "ESPIA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Conflito",
      "words": [
        "GUERRA",
        "COMBATE",
        "BATALHA",
        "PELEJA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Coisas que picam",
      "words": [
        "ESPINHO",
        "FARPA",
        "TACHA",
        "AGULHA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Cume",
      "words": [
        "TOPO",
        "PICO",
        "AUGE",
        "PÍNCARO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Para fazer churrasco",
      "words": [
        "BRASA",
        "ESPETO",
        "CARNE",
        "GRELHA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Posições no futebol",
      "words": [
        "PONTA",
        "ALA",
        "LÍBERO",
        "LATERAL"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Depressão do terreno",
      "words": [
        "ENCOSTA",
        "DECLIVE",
        "LADEIRA",
        "QUEBRADA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Ponto de _____",
      "words": [
        "EQUILÍBRIO",
        "ÔNIBUS",
        "INTERROGAÇÃO",
        "REFERÊNCIA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Troça, zombaria",
      "words": [
        "PARTIDA",
        "BRINCADEIRA",
        "PEGADINHA",
        "PEÇA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Temática",
      "words": [
        "QUESTÃO",
        "ASSUNTO",
        "TEMA",
        "TÓPICO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Palíndromos",
      "words": [
        "OSSO",
        "RETER",
        "ARARA",
        "OCO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Aves",
      "words": [
        "PICA-PAU",
        "URUBU",
        "CARDEAL",
        "TICO-TICO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Louco",
      "words": [
        "BIRUTA",
        "TONTO",
        "DOIDO",
        "MALUCO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Novelas antigas",
      "words": [
        "TI-TI-TI",
        "CARROSSEL",
        "VAMP",
        "ARAPONGA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Peixe",
      "words": [
        "LUA",
        "SOL",
        "ELÉTRICO",
        "ESPADA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Municípios de Santa Catarina",
      "words": [
        "FLORIANÓPOLIS",
        "JOINVILLE",
        "TUBARÃO",
        "BLUMENAU"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Personagens do Scooby Doo",
      "words": [
        "VELMA",
        "DAPHNE",
        "FRED",
        "SCOOBY-DOO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Enlatados",
      "words": [
        "ATUM",
        "SARDINHA",
        "SALSICHA",
        "TOMATE"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Objetos em um quarto",
      "words": [
        "GUARDA-ROUPA",
        "PENTEADEIRA",
        "ESPELHO",
        "CAMA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Em que há conforto ou comodidade",
      "words": [
        "CONFORTÁVEL",
        "ACOLHEDORA",
        "CÔMODA",
        "ACONCHEGANTE"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Há no hospital",
      "words": [
        "PACIENTE",
        "MÉDICO",
        "ENFERMEIRA",
        "REMÉDIO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Músicas de Chico Buarque",
      "words": [
        "CÁLICE",
        "CONSTRUÇÃO",
        "VALSINHA",
        "CAROLINA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Bonança",
      "words": [
        "CALMARIA",
        "QUIETUDE",
        "SOSSEGO",
        "VENTURA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Bem fixo",
      "words": [
        "IMÓVEL",
        "PROPRIEDADE",
        "TERRENO",
        "PRÉDIO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Planetas",
      "words": [
        "MARTE",
        "VÊNUS",
        "TERRA",
        "JÚPITER"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Metais",
      "words": [
        "OURO",
        "PRATA",
        "BRONZE",
        "MERCÚRIO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Os 4 Elementos",
      "words": [
        "AR",
        "TERRA",
        "ÁGUA",
        "FOGO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Ambientes aquáticos",
      "words": [
        "RIO",
        "LAGOA",
        "PÂNTANO",
        "MAR"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Bairros do Rio de Janeiro",
      "words": [
        "TIJUCA",
        "ZUMBI",
        "URCA",
        "IPANEMA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Árvores de fruto",
      "words": [
        "MANGUEIRA",
        "JABUTICABEIRA",
        "GOIABEIRA",
        "LARANJEIRA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Para fumar",
      "words": [
        "CIGARRO",
        "CHARUTO",
        "CACHIMBO",
        "NARGUILÉ"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Sobrenomes de atrizes brasileiras",
      "words": [
        "MARQUEZINE",
        "MASSAFERA",
        "ANTONELLI",
        "DIECKMANN"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Da natação",
      "words": [
        "RAIA",
        "PISCINA",
        "CLORO",
        "TOUCA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Insetos",
      "words": [
        "BORBOLETA",
        "JOANINHA",
        "LIBÉLULA",
        "ABELHA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Formas de pagamento",
      "words": [
        "BOLETO",
        "NOTA",
        "CARTÃO",
        "PIX"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Permutação",
      "words": [
        "MUDANÇA",
        "TRANSFERÊNCIA",
        "TRANSIÇÃO",
        "TROCA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Objetos para sentar",
      "words": [
        "PUFE",
        "BANCO",
        "POLTRONA",
        "SOFÁ"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Articulação que liga o fêmur à pélvis",
      "words": [
        "QUADRIL",
        "ANCA",
        "ILHARGA",
        "CADEIRA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Primatas",
      "words": [
        "CHIMPANZÉ",
        "LÉMUR",
        "SAGUI",
        "GORILA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Trabalho extra",
      "words": [
        "BISCATE",
        "EXTRA",
        "GALHO",
        "GANCHO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Constrangimento",
      "words": [
        "VERGONHA",
        "VEXAME",
        "MICO",
        "VEXAÇÃO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Coisas ligadas a ornitorrinco",
      "words": [
        "BICO",
        "PELO",
        "OVO",
        "VENENO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Operações matemáticas",
      "words": [
        "ADIÇÃO",
        "SUBTRAÇÃO",
        "MULTIPLICAÇÃO",
        "DIVISÃO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Casa",
      "words": [
        "RESIDÊNCIA",
        "DOMICÍLIO",
        "HABITAÇÃO",
        "MORADIA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Vícios",
      "words": [
        "AÇÚCAR",
        "CIGARRO",
        "ÁLCOOL",
        "INTERNET"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Comidas redondas",
      "words": [
        "PIZZA",
        "DONUT",
        "BOLO",
        "EMPADA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Ato de se apoderar",
      "words": [
        "TOMADA",
        "CONQUISTA",
        "OCUPAÇÃO",
        "APODERAÇÃO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Material elétrico",
      "words": [
        "CABO",
        "DISJUNTOR",
        "INTERRUPTOR",
        "EXTENSÃO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Último filho a nascer",
      "words": [
        "BENJAMIM",
        "CAÇULA",
        "ULTIMOGÊNITO",
        "CAÇULÊ"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Pé de ____",
      "words": [
        "ATLETA",
        "MOLEQUE",
        "CABRA",
        "MOÇA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Estabelecimento que vende bebida e comida:",
      "words": [
        "BAR",
        "TABERNA",
        "BOTEQUIM",
        "TASCO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Sons de animais:",
      "words": [
        "PIO",
        "GRUNHIDO",
        "COAXO",
        "SILVO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Bagunça:",
      "words": [
        "ZORRA",
        "BADERNA",
        "DESORDEM",
        "CONFUSÃO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Palavras que com um “B” antes significam outra coisa:",
      "words": [
        "URRO",
        "ARRO",
        "ERRA",
        "IRRA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Coisas que queimam: ",
      "words": [
        "FÓSFORO",
        "VELA",
        "INCENSO",
        "TOCHA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Elementos Químicos: ",
      "words": [
        "ÍNDIO",
        "CARBONO",
        "HÉLIO",
        "LÍTIO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Conceitos indígenas: ",
      "words": [
        "OCA",
        "COCAR",
        "PAJÉ",
        "ARCO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Caça-____: ",
      "words": [
        "FANTASMAS",
        "NÍQUEIS",
        "PALAVRAS",
        "RATOS"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Partes de um vulcão:",
      "words": [
        "MAGMA",
        "CINZA",
        "CRATERA",
        "CHAMINÉ"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Partes de uma casa:",
      "words": [
        "TELHADO",
        "PAREDE",
        "JANELA",
        "PORTA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Ele faz tarefas domésticas. Ele:",
      "words": [
        "LAVA",
        "PASSA",
        "COZINHA",
        "LIMPA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Homem de _____:",
      "words": [
        "FERRO",
        "AÇO",
        "GELO",
        "LATA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Ações de culinária:",
      "words": [
        "CORTAR",
        "RALAR",
        "MISTURAR",
        "FATIAR"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Decorre:",
      "words": [
        "ACONTECE",
        "OCORRE",
        "SUCEDE",
        "ROLA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Adjetivos para vinhos: ",
      "words": [
        "FRUTADO",
        "GENEROSO",
        "AVELUDADO",
        "ÁSPERO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Comandos para cachorro: ",
      "words": [
        "FICA",
        "LATE",
        "DEITA",
        "GIRA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Animais de estimação:",
      "words": [
        "GATO",
        "CACHORRO",
        "COELHO",
        "FURÃO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Meia-___:",
      "words": [
        "NOITE",
        "IDADE",
        "CALÇA",
        "LUA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Roupas:",
      "words": [
        "BERMUDA",
        "SHORT",
        "SAIA",
        "JEANS"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Trava-língua conhecido:",
      "words": [
        "TRÊS",
        "TRISTES",
        "TIGRES",
        "PRATOS"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Concebe:",
      "words": [
        "ORGANIZA",
        "ARQUITETA",
        "PLANEJA",
        "PROGRAMA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Profissões:",
      "words": [
        "ENFERMEIRA",
        "ADVOGADA",
        "ENGENHEIRA",
        "COZINHEIRA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Partes de uma casa:",
      "words": [
        "CHÃO",
        "TETO",
        "PAREDE",
        "JANELA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Coisas que se podem bater:",
      "words": [
        "CONTINÊNCIA",
        "PONTO",
        "LAJE",
        "PALMAS"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Sobremesas: ",
      "words": [
        "CRÈME BRÛLÉE",
        "PROFITEROLE",
        "ÉCLAIR",
        "MIL FOLHAS"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Frutos Cítricos:",
      "words": [
        "TORANJA",
        "TOMATE",
        "ROMÃ",
        "PONCÃ"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Pintores Surrealistas:",
      "words": [
        "MIRÓ",
        "MAGRITTE",
        "DALI",
        "KAHLO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Móveis para Casa:",
      "words": [
        "ABAJUR",
        "CABECEIRA",
        "CÔMODA",
        "BANQUETA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Grandezas Elétricas:",
      "words": [
        "TENSÃO",
        "CORRENTE",
        "RESISTÊNCIA",
        "POTÊNCIA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Sentimentos Negativos:",
      "words": [
        "CHOQUE",
        "AVERSÃO",
        "TORPOR",
        "PERTURBAÇÃO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Danças Típicas:",
      "words": [
        "CARIMBÓ",
        "MARACATU",
        "FREVO",
        "BAIÃO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Escritoras Brasileiras:",
      "words": [
        "CORALINA",
        "EVARISTO",
        "LISPECTOR",
        "QUEIROZ"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Membros Inferiores do Corpo Humano:",
      "words": [
        "PÉS",
        "PERNAS",
        "COXAS",
        "QUADRIL"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Órgãos do Sistema Respiratório:",
      "words": [
        "PULMÃO",
        "BRONQUÍOLO",
        "ALVÉOLO",
        "TRAQUEIA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Animais Mamíferos:",
      "words": [
        "CACHORRO",
        "ORNITORRINCO",
        "BALEIA",
        "TOUPEIRA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Ferramentas Mecânicas:",
      "words": [
        "MACACO",
        "GRUA",
        "ALICATE",
        "FONOSCÓPIO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Prefixos Latinos:",
      "words": [
        "RETRO",
        "CONTRA",
        "INTRA",
        "ULTRA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Verticilos Florais:",
      "words": [
        "CÁLICE",
        "COROLA",
        "ANDROCEU",
        "GINECEU"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Sistema Urinário:",
      "words": [
        "RIM",
        "URETER",
        "ADRENAL",
        "PARÊNQUIMA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Componentes da Fecundação:",
      "words": [
        "ÓVULO",
        "ESPERMATOZOIDE",
        "ÚTERO",
        "TROMPAS DE FALÓPIO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Partes de uma casa",
      "words": [
        "JANELA",
        "TELHADO",
        "PAREDE",
        "ESCADA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "O mesmo que passagem",
      "words": [
        "CAMINHO",
        "GARGANTA",
        "PORTA ",
        "BRECHA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Itens de um barco",
      "words": [
        "VELA",
        "CABINE",
        "MOTOR",
        "BOIA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Guarda-",
      "words": [
        "CHUVA",
        "ROUPA",
        "COSTAS",
        "LIVROS"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Profissões da saúde",
      "words": [
        "BIÓLOGO",
        "MÉDICO",
        "DENTISTA",
        "FARMACÊUTICO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Itens de iluminação",
      "words": [
        "ABAJUR",
        "LUMINÁRIA",
        "LUSTRE",
        "PENDENTE"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Literatura",
      "words": [
        "LIVRO",
        "AUTOR",
        "ESCRITA",
        "IDEIA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Palavras proparoxítonas",
      "words": [
        "MATEMÁTICA",
        "PRÍNCIPE",
        "LÂMPADA",
        "FÍSICO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Estados brasileiros",
      "words": [
        "MINAS GERAIS",
        "MATO GROSSO",
        "SÃO PAULO",
        "ESPÍRITO SANTO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Rios",
      "words": [
        "AMAZONAS",
        "SÃO FRANCISCO",
        "NILO",
        "GANGES"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Flores",
      "words": [
        "PERPÉTUA",
        "MAGNÓLIA",
        "CRAVO",
        "ROSA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Cores",
      "words": [
        "ENCARNADO",
        "CASTANHO",
        "VIOLETA",
        "VERDE"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "O mesmo que comum",
      "words": [
        "MODESTO",
        "SINGELO",
        "SIMPLES",
        "HABITUAL"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Bolo",
      "words": [
        "INGLÊS",
        "AMANTEIGADO",
        "COMUM",
        "DE CENOURA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Alimentos",
      "words": [
        "CENOURA",
        "BISCOITO",
        "LARANJA",
        "MANGOSTÃO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Língua estrangeiras",
      "words": [
        "ESPANHOL",
        "NAVAJO",
        "ALEMÃO",
        "ÁRABE"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Tipos de molho",
      "words": [
        "MADEIRA",
        "TÁRTARO",
        "ALFREDO",
        "BRANCO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Formas de relevo",
      "words": [
        "MONTANHA",
        "PLANÍCIE",
        "DEPRESSÃO",
        "VALE"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Coletivos",
      "words": [
        "TURMA",
        "ENXAME",
        "FLORESTA",
        "MOLHO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Palavras compostas",
      "words": [
        "MERCOSUL",
        "PLANALTO",
        "AGRIDOCE",
        "VINAGRE"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Ervas Aromáticas",
      "words": [
        "ALECRIM",
        "MANJERICÃO",
        "HORTELÃ",
        "ORÉGANO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Temperos",
      "words": [
        "PIMENTA",
        "ALHO",
        "COMINHO",
        "SAL"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Brinquedos Infantils",
      "words": [
        "BONECA",
        "CARRINHO",
        "BLOCOS",
        "BOLA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Pedras Preciosas",
      "words": [
        "RUBI",
        "SAFIRA",
        "DIAMANTE",
        "AMETISTA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Filmes Brasileiros",
      "words": [
        "BACURAU",
        "TAINÁ",
        "OLGA",
        "ARUANDA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Nomes Indígenas",
      "words": [
        "IARA",
        "JACI",
        "JUREMA",
        "POTIRA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Bairros de Belo Horizonte",
      "words": [
        "SAVASSI",
        "STA.TEREZA",
        "PAMPULHA",
        "LOURDES"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Comidas Típicas",
      "words": [
        "ANGU",
        "PÃO DE QUEIJO",
        "CANJICA",
        "FEIJOADA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Tem no Xadrez",
      "words": [
        "REI",
        "RAINHA",
        "CAVALO",
        "TORRE"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Títulos Católicos",
      "words": [
        "BISPO",
        "CARDEAL",
        "PAPA",
        "DIÁCONO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Sobrenoms Comuns",
      "words": [
        "SILVA",
        "SANTOS",
        "OLIVEIRA",
        "SOUZA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Municípios Paraenses",
      "words": [
        "BELÉM",
        "SANTARÉM",
        "MARABÁ",
        "CASTANHAL"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Palavras com hífen",
      "words": [
        "GUARDA-CHUVA",
        "SEGUNDA-FEIRA",
        "AUTO-HIPNOSE",
        "BEM-VINDO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Tem no Hino Nacional",
      "words": [
        "BRASIL",
        "PÁTRIA",
        "LIBERDADE",
        "GIGANTE"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Para fazer a barba",
      "words": [
        "LÂMINA",
        "ESPUMA",
        "NAVALHA",
        "BARBEADOR"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Tem no Cabeleireiro",
      "words": [
        "TESOURA",
        "PENTE",
        "SECADOR",
        "ESCOVA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Dispara:",
      "words": [
        "ATIRA",
        "JOGA",
        "ARREMESSA",
        "IMPELE"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Armas",
      "words": [
        "LANÇA",
        "ARCO",
        "FUNDA",
        "BESTA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Partes de um microscópio",
      "words": [
        "LÂMINA",
        "LENTE",
        "CANHÃO",
        "BASE"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Frase que se repete muito",
      "words": [
        "CHAVÃO",
        "CHAPA",
        "CLICHÊ",
        "BORDÃO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Terminado:",
      "words": [
        "REALIZADO",
        "ELABORADO",
        "OPERADO",
        "DESENVOLVIDO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Resultado favorável",
      "words": [
        "FEITO",
        "VITÓRIA",
        "CONQUISTA",
        "TRIUNFO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Destino",
      "words": [
        "SINA",
        "FADO",
        "SORTE",
        "FORTUNA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Dança popular",
      "words": [
        "COCO",
        "BAIÃO",
        "XOTE",
        "FORRÓ"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Piso",
      "words": [
        "CHÃO",
        "TERRENO",
        "SUPERFÍCIE",
        "PAVIMENTO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Coisas que se movimentam no ar",
      "words": [
        "DRONE",
        "PIPA",
        "FOGUETE",
        "BALÃO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Que tem asa",
      "words": [
        "XÍCARA",
        "AVIÃO",
        "ANJO",
        "MORCEGO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Relativo ao Star Wars",
      "words": [
        "FORÇA",
        "ROBÔ",
        "SOLO",
        "CLONE"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Enumeração de coisas",
      "words": [
        "ÍNDICE",
        "LISTA",
        "ROL",
        "TABELA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Partes de um livro",
      "words": [
        "ORELHA",
        "LOMBADA",
        "CAPA",
        "SUMÁRIO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Componentes de uma cadeira",
      "words": [
        "BRAÇO",
        "PÉ",
        "ASSENTO",
        "ENCOSTO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Bambalalão... Senhor Capitão...",
      "words": [
        "ESPADA",
        "CINTA",
        "GINETE",
        "MÃO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Tipos de força",
      "words": [
        "ATRITO",
        "PESO",
        "GRAVIDADE",
        "NORMAL"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Habitual:",
      "words": [
        "USUAL",
        "COMUM",
        "NATURAL",
        "ORDINÁRIO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Abelha-",
      "words": [
        "AFRICANA",
        "RAINHA",
        "EUROPEIA",
        "AMARELA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Títulos de nobreza",
      "words": [
        "MARQUESA",
        "DUQUE",
        "INFANTE",
        "PRINCESA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Cidades do Canadá",
      "words": [
        "VANCOUVER",
        "TORONTO",
        "QUEBEC",
        "OTTAWA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Marcas de tênis dos anos 80",
      "words": [
        "KICHUTE",
        "BAMBA",
        "CONGA",
        "MONTREAL"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Peças de um notebook",
      "words": [
        "MEMÓRIA",
        "BATERIA",
        "TECLADO",
        "PLACA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Que tem brilho:",
      "words": [
        "VAGALUME",
        "DIAMANTE",
        "ESTRELA",
        "TELA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Meios de transporte fluvial",
      "words": [
        "CHALANA",
        "LANCHA",
        "BARCO",
        "CATARAMÃ"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Nomes de perfume",
      "words": [
        "KAIAK",
        "ESSENCIAL",
        "HUMOR",
        "QUASAR"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Necessário:",
      "words": [
        "FUNDAMENTAL",
        "INDISPENSÁVEL",
        "BÁSICO",
        "FORÇOSO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Tipos de uva",
      "words": [
        "TANNAT",
        "MERLOT",
        "MALBEC",
        "BARBERA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Canais de TV",
      "words": [
        "RECORD",
        "SBT",
        "MTV",
        "CULTURA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Há na escola:",
      "words": [
        "PROFESSORES",
        "CARTEIRA",
        "PÁTIO",
        "DIREÇÃO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Papel-",
      "words": [
        "CARBONO",
        "CELOFANE",
        "FILME",
        "MOEDA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Obras de Tarsila do Amaral",
      "words": [
        "ABAPORU",
        "OPERÁRIOS",
        "ANTROPOFAGIA",
        "CRIANÇAS"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Marcas Famosas",
      "words": [
        "ANTÁRTICA",
        "QUERO",
        "UNIVERSAL",
        "GILLETE"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Celebridades",
      "words": [
        "ANGÉLICA",
        "MADONNA",
        "PELÉ",
        "CAZUZA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Sobrenomes",
      "words": [
        "MACHADO",
        "SANTOS",
        "FERNANDES",
        "ALMEIDA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Substantivos Abstratos",
      "words": [
        "BELEZA",
        "CIÚME",
        "POBREZA",
        "HONESTIDADE"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "O Brasil é ___",
      "words": [
        "SUL-AMERICANO",
        "TROPICAL",
        "MULTICULTURAL",
        "IMENSO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "O açúcar pode ser ___",
      "words": [
        "CRISTAL",
        "REFINADO",
        "ORGÂNICO",
        "MASCAVADO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Sabores de Sorvete",
      "words": [
        "CHOCOLATE",
        "BAUNILHA",
        "MORANGO",
        "MARACUJÁ"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Sintomas do Alzheimer",
      "words": [
        "AMNÉSIA",
        "AGRESSIVIDADE",
        "IRRITABILIDADE",
        "DESORIENTAÇÃO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Chá de ___",
      "words": [
        "CAMOMILA",
        "ERVA-DOCE",
        "GENGIBRE",
        "HORTELÃ"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Biomas Brasileiros:",
      "words": [
        "PANTANAL",
        "CERRADO",
        "CAATINGA",
        "PAMPA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Línguas Indígenas:",
      "words": [
        "TIKUNA",
        "GUARANI",
        "XAVANTE",
        "YANOMAMI"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Afluentes do Rio São Francisco:",
      "words": [
        "PARACATU",
        "ABAETÉ",
        "JEQUITAÍ",
        "PAJEÚ"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Tecidos de Luxo:",
      "words": [
        "SEDA",
        "LINHO",
        "VELUDO",
        "CAXEMIRA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Objetos Decorativos",
      "words": [
        "CASTIÇAL",
        "ESCULTURA",
        "RELÓGIO",
        "LUSTRE"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Triste:",
      "words": [
        "SORUMBÁTICO",
        "TACITURNO",
        "MACAMBÚZIO",
        "MELANCÓLICO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Consentimento:",
      "words": [
        "ANUÊNCIA",
        "AQUIESCÊNCIA",
        "AUTORIZAÇÃO",
        "CONCORDÂNCIA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Formas Geométricas",
      "words": [
        "DECÁGONO",
        "ENEÁGONO",
        "HEPTÁGONO",
        "QUADRILÁTERO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Soldagem por",
      "words": [
        "ATRITO",
        "LASER",
        "RESISTÊNCIA",
        "METAL"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Compostos Naturais:",
      "words": [
        "PROTEÍNA",
        "LIPÍDEO",
        "ENZIMA",
        "PETRÓLEO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Máscara…",
      "words": [
        "HIDRATANTE",
        "CARNAVALESCA",
        "FACIAL",
        "CAPILAR"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Cores de Cabelo…",
      "words": [
        "PRETO",
        "CASTANHO",
        "LOIRO",
        "RUIVO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Tipos de Lâmpada:",
      "words": [
        "LED",
        "FILAMENTO",
        "HALOGÊNIO",
        "FLUORESCENTE"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Unidades de Medida:",
      "words": [
        "PÉ",
        "PALMO",
        "MILHA",
        "METRO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Vulpino:",
      "words": [
        "MEFISTOFÉLICO",
        "PÉRFIDO",
        "INFERNAL",
        "PRODITÓRIO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Sons de animais:",
      "words": [
        "ZUMBIR",
        "REGOUGAR",
        "GRINFAR",
        "BUFAR"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Animais com a letra C:",
      "words": [
        "CAMUNDONGO",
        "CEGONHA",
        "CAPIVARA",
        "CANÁRIO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Tem no Galinheiro:",
      "words": [
        "GALINHA",
        "OVO",
        "POLEIRO",
        "NINHO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Bebidas com Café:",
      "words": [
        "EXPRESSO",
        "CAPUCHINO",
        "FRAPPÉ",
        "MOCCA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Água…",
      "words": [
        "SALINA",
        "DOCE",
        "SALOBRA",
        "SUBTERRÂNEA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Signos Chineses:",
      "words": [
        "RATO",
        "BOI",
        "DRAGÃO",
        "PORCO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Espécies de Madeira:",
      "words": [
        "AFIZÉLIA",
        "AFROMÓSIA",
        "ANDIROBA",
        "ANGELIM"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Constelações:",
      "words": [
        "ANDROMEDA",
        "CRUZEIRO DO SUL",
        "URSA MAIOR",
        "PERSEU"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Naipes do Baralho",
      "words": [
        "OURO",
        "COPAS",
        "PAUS",
        "ESPADA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Estrangeirismos:",
      "words": [
        "SHOW",
        "SELFIE",
        "ACORDÉON",
        "ATELIER"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Papel…",
      "words": [
        "TOALHA",
        "HIGIÊNICO",
        "QUADRICULADO",
        "VEGETAL"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Queijo tipo…",
      "words": [
        "FETA",
        "MINAS",
        "CATUPIRY",
        "CANASTRA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Agradável",
      "words": [
        "BRANDO",
        "AFÁVEL",
        "APRAZÍVEL",
        "AMENO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Sacode:",
      "words": [
        "BALANÇA",
        "BRANDE",
        "OSCILA",
        "ARFA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Instrumentos de medição",
      "words": [
        "FITA MÉTRICA",
        "ADIPÔMETRO",
        "RÉGUA",
        "RELÓGIO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Erva-",
      "words": [
        "DOCE",
        "ARANHA",
        "MATE",
        "AZEDA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Escolas de samba do Rio de Janeiro",
      "words": [
        "BEIJA-FLOR",
        "SALGUEIRO",
        "PORTELA",
        "MOCIDADE"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Tem no caminhão de bombeiro",
      "words": [
        "MANGUEIRA",
        "EXTINTOR",
        "ESCADA",
        "TANQUE"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Nomes de árvores",
      "words": [
        "OLIVEIRA",
        "CARNAÚBA",
        "CARVALHO",
        "MANACÁ"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Plantas medicinais",
      "words": [
        "BABOSA",
        "CARQUEJA",
        "CONFREI",
        "GUACO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Aperitivos",
      "words": [
        "TORRESMO",
        "CROQUETE",
        "AMENDOIM",
        "CANAPÉ"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Expatriado",
      "words": [
        "EXILADO",
        "BANIDO",
        "PROSCRITO",
        "DEGREDADO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Técnicas de pintura",
      "words": [
        "AQUARELA",
        "PASTEL",
        "GUACHE",
        "ACRÍLICA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Músicas de Caetano Veloso",
      "words": [
        "LEÃOZINHO",
        "TROPICÁLIA",
        "SOZINHO",
        "SAMPA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Que vive de regalias:",
      "words": [
        "MARAJÁ",
        "MAGNATA",
        "SULTÃO",
        "OLIGARCA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Ilhas brasileiras",
      "words": [
        "MARAJÓ",
        "BOIPEBA",
        "ITAMARACÁ",
        "ITAPARICA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Sérgio",
      "words": [
        "MALANDRO",
        "REIS",
        "MORO",
        "NORONHA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Mesmo que bandido",
      "words": [
        "BANDOLEIRO",
        "MALFEITOR",
        "SALTEADOR",
        "FACÍNORA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Mesmo que impedida",
      "words": [
        "EMBARGADA",
        "OBSTRUÍDA",
        "INTERCEPTADA",
        "INIBIDA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Expressões do vôlei",
      "words": [
        "CORTADA",
        "MANCHETE",
        "SAQUE",
        "PEIXINHO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Peixes comuns na culinária",
      "words": [
        "DOURADO",
        "ROBALO",
        "TRAÍRA",
        "TILÁPIA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Personagens de “A Pequena Sereia”",
      "words": [
        "LINGUADO",
        "ÚRSULA",
        "SABIDÃO",
        "TRAVESSO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "O tomate é vendido em:",
      "words": [
        "POLPA",
        "EXTRATO",
        "MOLHO",
        "PASSATA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Ela economiza. Ela:",
      "words": [
        "POUPA",
        "RESERVA",
        "JUNTA",
        "AMEALHA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "O mesmo que cuidadoso",
      "words": [
        "ATENTO",
        "DILIGENTE",
        "DESVELADO",
        "PREOCUPADO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Tipos de vinho",
      "words": [
        "RESERVADO",
        "FORTE",
        "ENCORPADO",
        "DOCE"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Resultados das 4 operações básicas",
      "words": [
        "SOMA",
        "DIFERENÇA",
        "PRODUTO",
        "QUOCIENTE"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Tem no Teorema de Pitágoras:",
      "words": [
        "QUADRADO",
        "MEDIDA",
        "HIPOTENUSA",
        "CATETO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Produtos de porco:",
      "words": [
        "LOMBO",
        "TOUCINHO",
        "PANCETTA",
        "PROSCIUTTO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Sobrenomes de cientistas:",
      "words": [
        "BACON",
        "GALILEI",
        "NEWTON",
        "DESCARTES"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Sem impurezas",
      "words": [
        "PURO",
        "REFINADO",
        "LÍMPIDO",
        "GENUÍNO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Sal...",
      "words": [
        "GROSSO",
        "MARINHO",
        "IODADO",
        "NEGRO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Tem no alfabeto fonético",
      "words": [
        "BRAVO",
        "DELTA",
        "ECO",
        "ROMEU"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "São personagens de Shakespeare:",
      "words": [
        "HAMLET",
        "LEAR",
        "MACBETH",
        "JULIETA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Negócio escuso",
      "words": [
        "MARACUTAIA",
        "TRAFICÂNCIA",
        "FRAUDE",
        "FALCATRUA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Sentimentos negativos",
      "words": [
        "COVARDIA",
        "EGOÍSMO",
        "HUMILHAÇÃO",
        "PRECONCEITO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "São pecados capitais:",
      "words": [
        "SOBERBA",
        "AVAREZA",
        "INVEJA",
        "IRA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Animais que vivem na Amazônia:",
      "words": [
        "ANACONDA",
        "HARPIA",
        "BOTO",
        "PREGUIÇA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Comidas mineiras",
      "words": [
        "TORRESMO",
        "TROPEIRO",
        "CANJIQUINHA",
        "PÃO DE QUEIJO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Mesmo que dinheiro",
      "words": [
        "TUTU",
        "TROCADO",
        "VINTÉM",
        "TOSTÃO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Usados para afastar coisas indesejadas",
      "words": [
        "ALHO",
        "CARRANCA",
        "FERRADURA",
        "AMULETO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Existem na Terra de Oz",
      "words": [
        "ESPANTALHO",
        "TOTÓ",
        "DOROTHY",
        "LEÃO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Produtos de limpeza",
      "words": [
        "DESINFETANTE",
        "ESFREGÃO",
        "CLORO",
        "CERA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Pedra…",
      "words": [
        "SABÃO",
        "FILOSOFAL",
        "PRECIOSA",
        "LASCADA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Países que falam português",
      "words": [
        "ANGOLA",
        "MOÇAMBIQUE",
        "CABO VERDE",
        "PORTUGAL"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Países da América Central",
      "words": [
        "COSTA RICA",
        "CUBA",
        "GUATEMALA",
        "PANAMÁ"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Métodos de gestão do tempo",
      "words": [
        "CHECKLIST",
        "SMART",
        "KANBAN",
        "POMODORO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Representações gráficas",
      "words": [
        "ESQUEMA",
        "DIAGRAMA",
        "INFOGRÁFICO",
        "TABELA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Tipos de calendário",
      "words": [
        "GREGORIANO",
        "CHINÊS",
        "JULIANO",
        "MAIA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Nomes masculinos",
      "words": [
        "ÍCARO",
        "LORENZO",
        "RAFAEL",
        "LUCIANO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Capacidade de se colocar no lugar de outra pessoa:",
      "words": [
        "EMPATIA",
        "COMPREENSÃO",
        "ENTENDIMENTO",
        "INTROPIA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Qualidade das matérias que podem ser moldadas:",
      "words": [
        "PLASTICIDADE",
        "FLEXIBILIDADE",
        "ELASTICIDADE",
        "MALEABILIDADE"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Ponto Fraco:",
      "words": [
        "CALCANHAR DE AQUILES",
        "FRAQUEZA",
        "SUSCETIBILIDADE",
        "DEBILIDADE",
        ""
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Fases da Lua:",
      "words": [
        "CRESCENTE",
        "CHEIA",
        "MINGUANTE",
        "NOVA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Tipos de Prisma:",
      "words": [
        "TRIANGULAR",
        "QUADRANGULAR",
        "PENTAGONAL",
        "HEXAGONAL"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Laureados com o Nobel:",
      "words": [
        "SARAMAGO",
        "EINSTEIN",
        "CURIE",
        "MALALA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Filmes que ganharam o Óscar:",
      "words": [
        "ARGO",
        "PARASITA",
        "O ARTISTA",
        "CHICAGO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Navios famosos:",
      "words": [
        "TITANIC",
        "BRITANNIC",
        "LUSITANIA",
        "CARPATHIA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Verbos Regulares:",
      "words": [
        "AMAR",
        "APRENDER",
        "ABRIR",
        "SUBIR"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Classificação dos animais pela sua dieta:",
      "words": [
        "HERBÍVORO",
        "ONÍVORO",
        "CARNÍVORO",
        "DETRITÍVORO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Signos do Zodíaco:",
      "words": [
        "CÂNCER",
        "VIRGEM",
        "GÊMEOS",
        "TOURO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Doenças Respiratórias",
      "words": [
        "ASMA",
        "BRONQUITE",
        "RINITE",
        "SINUSITE"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Retalhado",
      "words": [
        "CERRADO",
        "CORTADO",
        "FENDIDO",
        "PARTIDO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Livros que inspiraram filmes",
      "words": [
        "DUNA",
        "HOBBIT",
        "EXTRAORDINÁRIO",
        "CREPÚSCULO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Biomas do mundo",
      "words": [
        "DESERTO",
        "SAVANA",
        "CAMPO",
        "TUNDRA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Fora do comum",
      "words": [
        "SURPREENDENTE",
        "SINGULAR",
        "ANÔMALO",
        "INSÓLITO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Modelos de bolsa",
      "words": [
        "ENVELOPE",
        "POCHETE",
        "BAÚ",
        "MOCHILA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Estilistas famosos",
      "words": [
        "DIOR",
        "PRADA",
        "ARMANI",
        "VERSACE"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Cortes de cabelo",
      "words": [
        "CHANEL",
        "MULLET",
        "ASSIMÉTRICO",
        "REPICADO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Terreno",
      "words": [
        "ACIDENTADO",
        "ÁSPERO",
        "DESNIVELADO",
        "IRREGULAR"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Vincula",
      "words": [
        "UNE",
        "PRENDE",
        "ATRELA",
        "AMARRA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Aliança entre pessoas",
      "words": [
        "LIGA",
        "BANDO",
        "FACÇÃO",
        "PARTIDO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Junção de partes do corpo",
      "words": [
        "JUNTA",
        "ARTICULAÇÃO",
        "JUNTURA",
        "LIGAMENTO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Gêneros textuais",
      "words": [
        "ATA",
        "RELATO",
        "LENDA",
        "BLOG"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Servem para vedar",
      "words": [
        "ROLHA",
        "LACRE",
        "TAMPA",
        "SILICONE"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Tem na pizza",
      "words": [
        "BORDA",
        "RECHEIO",
        "MASSA",
        "MOLHO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Gírias da internet",
      "words": [
        "BISCOITEIRO",
        "CRUSH",
        "NOJO",
        "SEXTOU"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Que fica ao redor",
      "words": [
        "CONTORNO",
        "CIRCUNFERÊNCIA",
        "VOLTA",
        "PERÍMETRO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Principais componentes da tecnologia moderna:",
      "words": [
        "COMPUTADOR",
        "INTERNET",
        "SOFTWARE",
        "ROBÓTICA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Disciplinas científicas estudadas atualmente:",
      "words": [
        "FÍSICA",
        "QUÍMICA",
        "BIOLOGIA",
        "ASTRONOMIA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Campos importantes na área da saúde:",
      "words": [
        "MEDICINA",
        "NUTRIÇÃO",
        "PSICOLOGIA",
        "ENFERMAGEM"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Pontos-chave para a preservação do Meio Ambiente:",
      "words": [
        "SUSTENTABILIDADE",
        "RECICLAGEM",
        "REPROCESSAMENTO",
        "REUTILIZAÇÃO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Fatores que influenciam a Economia:",
      "words": [
        "MERCADO",
        "FINANÇAS",
        "INVESTIMENTO",
        "INFLAÇÃO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Elementos expressivos de uma Cultura:",
      "words": [
        "MÚSICA",
        "ARTE",
        "LITERATURA",
        "CINEMA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Esportes praticados ao redor do mundo:",
      "words": [
        "FUTEBOL",
        "ATLETISMO",
        "NATAÇÃO",
        "BASQUETE"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Um sistema político é formado por…",
      "words": [
        "GOVERNO",
        "ELEIÇÕES",
        "DEMOCRACIA",
        "LEGISLAÇÃO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "A sociologia se pauta no estudo de…",
      "words": [
        "SOCIEDADE",
        "ESTRUTURA SOCIAL",
        "COMPORTAMENTO",
        "CULTURA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Estuda-se em História:",
      "words": [
        "CIVILIZAÇÕES",
        "GUERRAS",
        "REVOLUÇÕES",
        "ERAS"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Principais ramos da Filosofia:",
      "words": [
        "ÉTICA",
        "METAFÍSICA",
        "EPISTEMOLOGIA",
        "EXISTENCIALISMO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Na base das religiões é possível encontrar…",
      "words": [
        "ESPIRITUALIDADE",
        "RITUAIS",
        "CRENÇAS",
        "FÉ"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Pode ser estudado na Psicologia:",
      "words": [
        "COGNIÇÃO",
        "COMPORTAMENTO",
        "EMOÇÕES",
        "SENTIMENTOS"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Faz parte do sistema jurídico:",
      "words": [
        "LEIS",
        "JUSTIÇA",
        "CONSTITUIÇÃO",
        "TRIBUNAIS"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Meios de comunicação:",
      "words": [
        "MÍDIA",
        "JORNALISMO",
        "PUBLICIDADE",
        "REDES SOCIAIS"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Um engenheiro pode trabalhar com…",
      "words": [
        "CONSTRUÇÃO",
        "PROJETO",
        "INOVAÇÃO",
        "INFRAESTRUTURA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Estuda-se em Arquitetura:",
      "words": [
        "EDIFÍCIO",
        "DESIGN",
        "PLANEJAMENTO URBANO",
        "CONSTRUÇÃO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Principais gêneros literários:",
      "words": [
        "ROMANCE",
        "POESIA",
        "CONTO",
        "CRÔNICA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Uma música é essencialmente criada a partir de:",
      "words": [
        "INSTRUMENTO",
        "COMPOSIÇÃO",
        "INSPIRAÇÃO",
        "MELODIA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Formas mais comuns de artes visuais:",
      "words": [
        "PINTURA",
        "ESCULTURA",
        "FOTOGRAFIA",
        "DESENHO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Tem na matemática:",
      "words": [
        "ÁLGEBRA",
        "GEOMETRIA",
        "CÁLCULO",
        "ESTATÍSTICA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Conceitos fundamentais da Física:",
      "words": [
        "MOVIMENTO",
        "ENERGIA",
        "FORÇA",
        "RELATIVIDADE"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Tem na Química:",
      "words": [
        "REAÇÕES",
        "ELEMENTOS",
        "COMPOSTOS",
        "ÁTOMOS"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "É possível estudar em biologia…",
      "words": [
        "ECOSSISTEMA",
        "EVOLUÇÃO",
        "GENÉTICA",
        "ORGANISMOS"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Áreas de estudo da Geografia:",
      "words": [
        "TERRITÓRIO",
        "CLIMA",
        "POPULAÇÃO",
        "MAPAS"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Encontra-se no Universo…",
      "words": [
        "ESTRELAS",
        "PLANETAS",
        "GALÁXIAS",
        "METEOROS"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Temas centrais da Antropologia:",
      "words": [
        "CULTURA",
        "EVOLUÇÃO HUMANA",
        "SOCIEDADE",
        "ETNOGRAFIA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Objetivos de uma boa prática médica:",
      "words": [
        "DIAGNÓSTICO",
        "TRATAMENTO",
        "PREVENÇÃO",
        "DOENÇAS"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Componentes importantes da nutrição:",
      "words": [
        "ALIMENTAÇÃO",
        "DIETA",
        "VITAMINAS",
        "METABOLISMO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Os conceitos essenciais da Ecologia são:",
      "words": [
        "ECOSSISTEMA",
        "CONSERVAÇÃO",
        "BIODIVERSIDADE",
        "SUSTENTABILIDADE"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Numa plantação tem:",
      "words": [
        "CULTIVO",
        "COLHEITA",
        "IRRIGAÇÃO",
        "HORTA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Uma empresa bem-sucedida é composta por…",
      "words": [
        "GESTÃO",
        "PLANEJAMENTO",
        "LIDERANÇA",
        "ESTRATÉGIA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Elementos-chave do Marketing:",
      "words": [
        "PROPAGANDA",
        "CONSUMIDOR",
        "PRODUTO",
        "PESQUISA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "O que envolve uma boa logística:",
      "words": [
        "TRANSPORTE",
        "ARMAZENAMENTO",
        "DISTRIBUIÇÃO",
        "INVENTÁRIO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Não pode faltar num itinerário:",
      "words": [
        "VIAGEM",
        "DESTINOS",
        "HOSPEDAGEM",
        "ATRAÇÕES"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Na gastronomia tem:",
      "words": [
        "CULINÁRIA",
        "CHEF",
        "RESTAURANTE",
        "INGREDIENTES"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Moda:",
      "words": [
        "ESTILO",
        "VESTUÁRIO",
        "DESIGN",
        "TENDÊNCIAS"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Um psicoterapeuta se foca na:",
      "words": [
        "ANÁLISE",
        "TERAPIA",
        "CONSCIÊNCIA",
        "RELACIONAMENTOS"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Elementos do Teatro:",
      "words": [
        "PEÇA",
        "ATUAÇÃO",
        "PALCO",
        "DIRETOR"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Numa filmagem tem:",
      "words": [
        "ATOR",
        "DIREÇÃO",
        "ROTEIRISTA",
        "PRODUÇÃO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Para uma fotografia é preciso...",
      "words": [
        "IMAGEM",
        "CÂMERA",
        "COMPOSIÇÃO",
        "PERSPECTIVA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Um designer trabalha com:",
      "words": [
        "PROJETO",
        "ESTÉTICA",
        "FUNCIONALIDADE",
        "INTERFACE"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Um programador trabalha com:",
      "words": [
        "PROGRAMAÇÃO",
        "DADOS",
        "ALGORITMO",
        "SISTEMA OPERACIONAL"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Objetivos que envolvem Serviço Social:",
      "words": [
        "ASSISTÊNCIA",
        "COMUNIDADE",
        "POLÍTICAS PÚBLICAS",
        "INCLUSÃO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "O que está dentro de uma pessoa",
      "words": [
        "ESSÊNCIA",
        "IDENTIDADE",
        "NATUREZA",
        "ÂMAGO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Início da vida",
      "words": [
        "INFÂNCIA",
        "PUERÍCIA",
        "PEQUENEZ",
        "MENINICE"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Coletivos de animais",
      "words": [
        "NUVEM",
        "ALCATEIA",
        "MANADA",
        "COLÔNIA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Fenômenos meteorológicos",
      "words": [
        "ARCO-ÍRIS",
        "GRANIZO",
        "NEVE",
        "AURORA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Vossa...",
      "words": [
        "EMINÊNCIA",
        "MERCÊ",
        "SANTIDADE",
        "SENHORIA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Tipos de mapa",
      "words": [
        "FÍSICO",
        "POLÍTICO",
        "DEMOGRÁFICO",
        "HISTÓRICO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Espectadores",
      "words": [
        "RODA",
        "TORCIDA",
        "AUDITÓRIO",
        "PLATEIA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Tem forma circular",
      "words": [
        "DISCO",
        "MEDALHA",
        "PRATO",
        "ANEL"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Falta de certeza",
      "words": [
        "DÚVIDA",
        "INCERTEZA",
        "INDECISÃO",
        "HESITAÇÃO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Jogadas decisivas",
      "words": [
        "XEQUE",
        "TRUCO",
        "NOCAUTE",
        "FINALIZAÇÃO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Confronto",
      "words": [
        "EMBATE",
        "CHOQUE",
        "CONFLITO",
        "LUTA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "São vícios de linguagem:",
      "words": [
        "PLEONASMO",
        "AMBIGUIDADE",
        "CACOFONIA",
        "COLISÃO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Charme",
      "words": [
        "MAGNETISMO",
        "ENCANTO",
        "BOROGODÓ",
        "FASCÍNIO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "São magnéticos:",
      "words": [
        "ÍMÃ",
        "POLO",
        "BÚSSOLA",
        "FERRO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "De pouco valor, insignificante:",
      "words": [
        "LANA-CAPRINA",
        "NINHARIA",
        "INSIGNIFICÂNCIA",
        "BAGATELA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Tem nas festas juninas",
      "words": [
        "VIS-À-VIS",
        "BALANCÊ",
        "ARRAIAL",
        "BANDEIROLA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Super-heróis:",
      "words": [
        "Batman",
        "Flash",
        "Wolverine",
        "Superman"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Notas musicais:",
      "words": [
        "sol",
        "ré",
        "mi",
        "dó"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Nomes de personagens caninos:",
      "words": [
        "Pluto",
        "Scooby-Doo",
        "Snoopy",
        "Bidu"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Funções no basquete:",
      "words": [
        "armador",
        "ala",
        "pivô",
        "lateral"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Estrangeirismos:",
      "words": [
        "mouse",
        "pizza",
        "réveillon",
        "software"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Tem no acougue:",
      "words": [
        "salsicha",
        "açougueiro",
        "linguiça",
        "balança"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Farinha de ______:",
      "words": [
        "trigo",
        "centeio",
        "sêmola",
        "milho"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Frutas:",
      "words": [
        "lichia",
        "mangostão",
        "pitaya",
        "romã"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Esportes radicais",
      "words": [
        "SURFE",
        "PARAPENTE",
        "ESCALADA",
        "CANOAGEM"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Esportes com bola",
      "words": [
        "FUTEBOL",
        "BASQUETE",
        "GOLFE",
        "TÊNIS"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Que une, segura ou conecta:",
      "words": [
        "CADARÇO",
        "LAÇO",
        "TRANÇA",
        "NÓ"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Roupas de uma bailarina",
      "words": [
        "SAPATILHA",
        "SAIA",
        "COLLANT",
        "MEIA-CALÇA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Saudações formais usadas em cartas",
      "words": [
        "PREZADO",
        "ESTIMADO",
        "EXCELENTÍSSIMO",
        "ILUSTRÍSSIMO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Que se gosta muito:",
      "words": [
        "XODÓ",
        "CARO",
        "QUERIDO",
        "QUISTO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Flores brancas",
      "words": [
        "LÍRIO",
        "JASMIM",
        "GARDÊNIA",
        "CAMÉLIA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Sobrenomes de escritores brasileiros",
      "words": [
        "ASSIS",
        "LISPECTOR",
        "AMADO",
        "ROSA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Sinais de pontuação",
      "words": [
        "COLCHETE",
        "PARÊNTESIS",
        "ASPAS",
        "TRAVESSÃO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Partes do Sistema Digestivo",
      "words": [
        "ESÔFAGO",
        "DUODENO",
        "JEJUNO",
        "CÓLON"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Coisas preciosas:",
      "words": [
        "RELÍQUIA",
        "MINA",
        "PRECIOSIDADE",
        "GEMA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Personagens do seriado Chaves",
      "words": [
        "TESOURO",
        "BARRIGA",
        "CHAVES",
        "CLOTILDE"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Deuses gregos",
      "words": [
        "ZEUS",
        "HADES",
        "POSEIDON",
        "ATENA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Monstros e seres mitológicos",
      "words": [
        "MEDUSA",
        "MINOTAURO",
        "HIDRA",
        "FÊNIX"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Pássaros tropicais",
      "words": [
        "ARARA",
        "TUCANO",
        "COLIBRI",
        "PAPAGAIO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Animais noturnos",
      "words": [
        "MORCEGO",
        "CORUJA",
        "GAMBÁ",
        "OURIÇO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Termos de jogos",
      "words": [
        "AVATAR",
        "NPC",
        "MISSÃO",
        "NÍVEL"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Falsificação digital",
      "words": [
        "DEEPFAKE",
        "DESINFORMAÇÃO",
        "MANIPULAÇÃO",
        "FRAUDE"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Que protege:",
      "words": [
        "COBERTURA",
        "REDOMA",
        "ESCUDO",
        "INVÓLUCRO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Coisas que estouram:",
      "words": [
        "BOLHA",
        "BALÃO",
        "PIPOCA",
        "PNEU"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Tipos de pelo",
      "words": [
        "CRINA",
        "PELAGEM",
        "JUBA",
        "BARBA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Estruturas de uma ave:",
      "words": [
        "PENA",
        "CLOACA",
        "BICO",
        "MOELA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Início de algo:",
      "words": [
        "SEMENTE",
        "EMBRIÃO",
        "ORIGEM",
        "COMEÇO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Gírias antigas para pessoa bonita",
      "words": [
        "BROTO",
        "PÃO",
        "AVIÃO",
        "COLÍRIO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Come-se antes da refeição principal:",
      "words": [
        "TAPA",
        "ENTRADA",
        "CHARCUTARIA",
        "PATÊ"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Pode-se fazer na prova:",
      "words": [
        "CHUTE",
        "RESPOSTA",
        "REVISÃO",
        "CORREÇÃO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Termos do futebol",
      "words": [
        "CARRINHO",
        "MARCAÇÃO",
        "PASSE",
        "FALTA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Grupos de pessoas",
      "words": [
        "PANELINHA",
        "BANDO",
        "GALERA",
        "MASSA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Símbolos usados na Internet:",
      "words": [
        "UNDERLINE",
        "HÍFEN",
        "HASHTAG",
        "PONTO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Unidades de medida",
      "words": [
        "ARROBA",
        "CÔVADO",
        "GRAMA",
        "LIBRA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Moedas:",
      "words": [
        "LIRA",
        "IENE",
        "REAL",
        "DÓLAR"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Instrumentos de sopro",
      "words": [
        "CLARINETE",
        "FAGOTE",
        "OBOÉ",
        "TROMPA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Contagem do tempo",
      "words": [
        "RELÓGIO",
        "CALENDÁRIO",
        "MINUTO",
        "ESTAÇÃO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Flexões do verbo",
      "words": [
        "TEMPO",
        "MODO",
        "NÚMERO",
        "PESSOA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Compõem um traje social:",
      "words": [
        "COSTUME",
        "TERNO",
        "CAMISA",
        "GRAVATA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Regras e práticas sociais",
      "words": [
        "ETIQUETA",
        "NORMA",
        "TRADIÇÃO",
        "CULTURA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Emoções fortes",
      "words": [
        "ANSIOSO",
        "SURPRESO",
        "ATÔNITO",
        "CHOCADO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Cor ou raça declarada no IBGE",
      "words": [
        "PRETO",
        "PARDO",
        "AMARELO",
        "INDÍGENA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Craques da Copa de 94",
      "words": [
        "BRANCO",
        "ROMÁRIO",
        "BEBETO",
        "CAFU"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Anões da Branca de Neve",
      "words": [
        "ZANGADO",
        "FELIZ",
        "DUNGA",
        "MESTRE"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Sentimentos de desejo e falta",
      "words": [
        "SAUDADE",
        "ANSEIO",
        "NOSTALGIA",
        "ANELO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Fora de moda:",
      "words": [
        "CRINGE",
        "BREGA",
        "CHINFRIM",
        "ULTRAPASSADA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Estilos de janela",
      "words": [
        "GUILHOTINA",
        "VENEZIANA",
        "BASCULANTE",
        "SANFONADA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Jogo da...",
      "words": [
        "FORCA",
        "VELHA",
        "VIDA",
        "MEMÓRIA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Materiais sustentáveis",
      "words": [
        "BAMBU",
        "ALGODÃO",
        "MADEIRA",
        "VIDRO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Império...",
      "words": [
        "BRITÂNICO",
        "ROMANO",
        "PERSA",
        "INCA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Tipos de copo",
      "words": [
        "TULIPA",
        "AMERICANO",
        "CÁLICE",
        "DESCARTÁVEL"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Flores de jardim",
      "words": [
        "HORTÊNSIA",
        "LAVANDA",
        "PETÚNIA",
        "CAMÉLIA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Elementos essenciais que impulsionam a inovação tecnológica:",
      "words": [
        "ALGORITMOS",
        "DADOS",
        "REDE",
        "CIBERSEGURANÇA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Principais preocupações ambientais discutidas atualmente:",
      "words": [
        "RECICLAGEM",
        "BIODIVERSIDADE",
        "ECOSSISTEMA",
        "CARBONO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Fatores fundamentais para manter uma vida saudável:",
      "words": [
        "EXERCÍCIO",
        "DIETA",
        "SONO",
        "TERAPIA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Pilares que sustentam o crescimento econômico:",
      "words": [
        "INVESTIMENTO",
        "MERCADO",
        "LUCRO",
        "EMPREGO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Ferramentas importantes para o sucesso de criadores em plataformas digitais:",
      "words": [
        "TIKTOK",
        "INFLUENCIADORES",
        "ENGAJAMENTO",
        "REDES SOCIAIS"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Principais produtos culturais que definem a onda coreana no cenário global:",
      "words": [
        "K-POP",
        "DORAMAS",
        "HALLYU",
        "CINEMA COREANO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Esportes com mais medalhas do Brasil nas olimpíadas:",
      "words": [
        "JUDÔ",
        "VELA",
        "ATLETISMO",
        "VÔLEI"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Tipos de Barco:",
      "words": [
        "LANCHA",
        "VELEIRO",
        "NAVIO",
        "IATE"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Programas de TV no Brasil",
      "words": [
        "NOVELA",
        "BBB",
        "MAIS VOCÊ",
        "DOMINGÃO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Conceitos semelhantes ao de “sextar”:",
      "words": [
        "COMEMORAR",
        "FESTEJAR",
        "RELAXAR",
        "DIVERTIR-SE"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Atividades para passar o tempo:",
      "words": [
        "MÚSICA",
        "LEITURA",
        "ARTESANATO",
        "ESCRITA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Para meditação é preciso__",
      "words": [
        "TRANQUILIDADE",
        "CONFORTO",
        "FOCO",
        "TEMPO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Métodos comuns usados numa pesquisa científica:",
      "words": [
        "QUANTITATIVO",
        "QUALITATIVO",
        "EXPERIMENTAL",
        "ANALÍTICO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Termos que descrevem diferentes níveis de integração entre as disciplinas acadêmicas:",
      "words": [
        "TRANSDISCIPLINARIDADE",
        "MULTIDISCIPLINARIDADE",
        "PLURALISMO",
        "SINERGIA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Componentes essenciais do processo hermenêutico na interpretação de textos:",
      "words": [
        "INTERPRETAÇÃO",
        "COMPREENSÃO",
        "TEXTO",
        "CONTEXTO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Principais conceitos estudados pela epistemologia:",
      "words": [
        "CETICISMO",
        "JUSTIFICAÇÃO",
        "VERDADE",
        "CONHECIMENTO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Gírias usadas pela Geração Z",
      "words": [
        "VIBE",
        "CRINGE",
        "SLAY",
        "SHIPPAR"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Abreviaturas usadas no Internetês: ",
      "words": [
        "LOL",
        "OMG",
        "TBT",
        "GIF"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Conteúdos comuns partilhados nas redes sociais:",
      "words": [
        "FOTOS",
        "STORIES",
        "REELS",
        "MEMES"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Para arrasar você precisa…",
      "words": [
        "IMPRESSIONAR",
        "BRILHAR",
        "DESLUMBRAR",
        "LACRAR"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Palavras típicas do mineiros:",
      "words": [
        "TREM",
        "UAI",
        "BÃO",
        "SÔ"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Exemplos de transporte terrestre:",
      "words": [
        "AUTOMÓVEL",
        "ÔNIBUS",
        "METRÔ",
        "CAMINHÃO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Para ser um bom(a) aluno é preciso… ",
      "words": [
        "PRODUTIVIDADE",
        "AUTONOMIA",
        "RESPONSABILIDADE",
        "COLABORAÇÃO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Termos que descrevem um conjunto de normas:",
      "words": [
        "DETERMINAÇÃO",
        "PROCEDIMENTO",
        "REGRA",
        "PRINCÍPIO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Exemplos de religiões monoteístas:",
      "words": [
        "CRISTIANISMO",
        "ISLAMISMO",
        "JUDAÍSMO",
        "SIQUISMO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Deuses da Mitologia Grega:",
      "words": [
        "ZEUS",
        "HERA",
        "POSEIDON",
        "HADES"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Nomes de Carros: ",
      "words": [
        "QUASAR",
        "HERMES",
        "ORION",
        "APOLO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Palavras de origem latina: ",
      "words": [
        "AQUEDUTO",
        "CIDADÃO",
        "MAGISTRADO",
        "LÍNGUA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Línguas que desapareceram: ",
      "words": [
        "ETRUSCO",
        "GÓTICO",
        "CELTA",
        "MAIA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Tipos de Calendário:",
      "words": [
        "GREGORIANO",
        "ETÍOPE",
        "CHINÊS",
        "JULIANO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Países situados na Ásia:",
      "words": [
        "ARMÊNIA",
        "TAILÂNDIA",
        "MALÁSIA",
        "INDONÉSIA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Palavras relacionadas ao estudo e à representação da Terra",
      "words": [
        "GEOLOGIA",
        "ECOLOGIA",
        "CARTOGRAFIA",
        "METEOROLOGIA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Em que há descanso",
      "words": [
        "ABRIGO",
        "RECANTO",
        "RETIRO",
        "PORTO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Local onde os animais se protegem",
      "words": [
        "NINHO",
        "BURACO",
        "APRISCO",
        "CURRAL"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Ações de contato",
      "words": [
        "TOCA",
        "RESVALA",
        "PEGA",
        "ESBARRA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Declive",
      "words": [
        "ENCOSTA",
        "VERTENTE",
        "LADEIRA",
        "DESCIDA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Elogios",
      "words": [
        "ÍMPAR",
        "AMISTOSO",
        "CULTO",
        "NOTÁVEL"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Dupla",
      "words": [
        "PAR",
        "DUETO",
        "CASAL",
        "DUO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Vocabulário de música",
      "words": [
        "MINUETO",
        "COREOGRAFIA",
        "DANÇA",
        "RITMO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Conjuntos numéricos",
      "words": [
        "NATURAL",
        "INTEIRO",
        "RACIONAL",
        "IRRACIONAL"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Beleza natural",
      "words": [
        "PRAIA",
        "MONTANHA",
        "FLORESTA",
        "CACHOEIRA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Representa o Brasil",
      "words": [
        "FEIJOADA",
        "AMAZÔNIA",
        "FUTEBOL",
        "CARNAVAL"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Tipos de Pão",
      "words": [
        "BAGUETE",
        "FORMA",
        "INTEGRAL",
        "SÍRIO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Coisas que irritam",
      "words": [
        "PERNILONGO",
        "ENGARRAFAMENTO",
        "LADAINHA",
        "GOTEIRA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Proteção de dados",
      "words": [
        "CHAVE",
        "SEGURANÇA",
        "SENHA",
        "ENIGMA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Serve como abrigo",
      "words": [
        "REFÚGIO",
        "GUARITA",
        "CABANA",
        "POUSADA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Gêneros cinematográficos",
      "words": [
        "AÇÃO",
        "FANTASIA",
        "FICÇÃO",
        "MISTÉRIO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Coisas importantes para lembrar",
      "words": [
        "COMPROMISSO",
        "ANIVERSÁRIO",
        "MEDICAMENTO",
        "CARTEIRA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Nomes de chocolate",
      "words": [
        "TALENTO",
        "PRESTÍGIO",
        "ALPINO",
        "CARIBE"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Ovo (de)",
      "words": [
        "PÁSCOA",
        "MEXIDO",
        "POCHÉ",
        "GALINHA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Cidades do sul do Brasil",
      "words": [
        "TUBARÃO",
        "CASCAVEL",
        "GRAMADO",
        "CURITIBA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Relativo ao Imposto de Renda",
      "words": [
        "LEÃO",
        "MALHA",
        "RENDA",
        "RECEITA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Ter grande sucesso",
      "words": [
        "BOMBAR",
        "DECOLAR",
        "ESTOURAR",
        "BRILHAR"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Substantivos (espaços e construções)",
      "words": [
        "LIMIAR",
        "PATAMAR",
        "PILAR",
        "LUGAR"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Sons da natureza (onomatopeias)",
      "words": [
        "CABRUM",
        "CHUÁ",
        "PIM",
        "ROAR"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Tem no Pinterest",
      "words": [
        "PIN",
        "IDEIA",
        "INSPIRAÇÃO",
        "DIY"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Materiais de escrita",
      "words": [
        "ROLO",
        "PAPEL",
        "PERGAMINHO",
        "PAPIRO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Situação difícil e complicada",
      "words": [
        "ZEBRA",
        "PERRENGUE",
        "TRETA",
        "B.O."
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Medidas de massa e peso",
      "words": [
        "ONÇA",
        "QUILO",
        "TONELADA",
        "ARROBA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Coisas que marcam",
      "words": [
        "SELO",
        "TATUAGEM",
        "CARIMBO",
        "CICATRIZ"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Animado",
      "words": [
        "ELÉTRICO",
        "VIBRANTE",
        "LIGADO",
        "VIVAZ"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Detergente em pó",
      "words": [
        "ARIEL",
        "BRILHANTE",
        "CAMPEIRO",
        "OMO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Professor(a)",
      "words": [
        "HELENA",
        "ALOPRADO",
        "RAIMUNDO",
        "MINERVA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Membros do X-men",
      "words": [
        "XAVIER",
        "FÊNIX",
        "TEMPESTADE",
        "CICLOPE"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Conceito éticos importantes para o desenvolvimento responsável da IA",
      "words": [
        "TRANSPARÊNCIA",
        "JUSTIÇA",
        "PRIVACIDADE",
        "RESPONSABILIDADE"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Princípios fundamentais para enfrentar os desafios ambientais globais",
      "words": [
        "SUSTENTABILIDADE",
        "REDUÇÃO",
        "REUSO",
        "RECICLAGEM"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Personagens digitais que representam usuários no metaverso",
      "words": [
        "AVATARES",
        "PERSONAS",
        "IDENTIDADES",
        "ALTEREGOS"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Termos para a pausa voluntária no uso de dispositivos digitais",
      "words": [
        "DESINTOXICAÇÃO",
        "DETOX",
        "PAUSA",
        "FÉRIAS"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Principais diferenças entre os dialetos do português falado no Brasil",
      "words": [
        "VARIAÇÃO",
        "SOTAQUE",
        "VOCABULÁRIO",
        "PRONÚNCIA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Tipos textuais mais usados:",
      "words": [
        "NARRAÇÃO",
        "DISSERTAÇÃO",
        "DESCRIÇÃO",
        "EXPOSIÇÃO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Palavras que já foram estrangeirismos:",
      "words": [
        "INTERNET",
        "SHOPPING",
        "E-MAIL",
        "SITE"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Gêneros Literários: ",
      "words": [
        "ROMANCE",
        "POESIA",
        "CONTO",
        "DRAMA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "As motocicletas são feitas de… ",
      "words": [
        "METAL",
        "PLÁSTICO",
        "BORRACHA",
        "AÇO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Fábrica de…",
      "words": [
        "AUTOMÓVEL",
        "TECIDO",
        "ALIMENTOS",
        "ELETRÔNICOS"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Produtos exportados pelo Brasil: ",
      "words": [
        "SOJA",
        "PETRÓLEO",
        "MINÉRIO",
        "CARNE"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Tipos de Ligações Iônicas:",
      "words": [
        "SIMPLES",
        "COMPLEXAS",
        "CRISTALINAS",
        "HIDRATADAS"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Conceitos que trazem a importância de brincar na infância: ",
      "words": [
        "DESENVOLVIMENTO",
        "SOCIALIZAÇÃO",
        "CRIATIVIDADE",
        "APRENDIZADO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Brinquedos de...",
      "words": [
        "MONTAR",
        "EDUCATIVOS",
        "IMITAÇÃO",
        "MOVIMENTO"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Sinônimos de felicidade… ",
      "words": [
        "ALEGRIA",
        "CONTENTAMENTO",
        "SATISFAÇÃO",
        "BEM-ESTAR"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Tópicos importantes no desenvolvimento de uma criança:",
      "words": [
        "BRINCAR",
        "EXPLORAR",
        "APRENDER",
        "SOCIALIZAR"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Categorias comuns no jogo STOP: ",
      "words": [
        "ANIMAIS",
        "CORES",
        "NOMES",
        "MARCAS"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "O que se pode encontrar num zoológico: ",
      "words": [
        "PESSOAS",
        "FELINOS",
        "HABITATS",
        "PÁSSAROS"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Para fazer pipoca é preciso… ",
      "words": [
        "MILHO",
        "ÓLEO",
        "PANELA",
        "SAL"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Componentes encontrados na água do mar:",
      "words": [
        "SÓDIO",
        "CLORO",
        "MAGNÉSIO",
        "CÁLCIO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Tem na fazenda:",
      "words": [
        "PLANTAS",
        "ANIMAIS",
        "FRUTAS",
        "TERRA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Para pescar é preciso… ",
      "words": [
        "VARA",
        "LINHA",
        "ISCA",
        "ANZOL"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Tipos de Animais Marítimos: ",
      "words": [
        "CRUSTÁCEOS",
        "MOLUSCOS",
        "PEIXES",
        "MAMÍFEROS"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Animais de Estimação: ",
      "words": [
        "PÁSSAROS",
        "GATOS",
        "CÃES",
        "COELHOS"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Sobrenomes de atrizes brasileiras: ",
      "words": [
        "MONTENEGRO",
        "PIRES",
        "SEVERO",
        "BRAGA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Livros de autores Brasileiros:",
      "words": [
        "SENHORA",
        "IRACEMA",
        "MACUNAÍMA",
        "O GUARANI"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "A revolução francesa tinha como ideias centrais: ",
      "words": [
        "LIBERDADE",
        "FRATERNIDADE",
        "IGUALDADE",
        "SOBERANIA POPULAR"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Países europeus: ",
      "words": [
        "FRANÇA",
        "ALEMANHA",
        "ITÁLIA",
        "ESPANHA"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Tipos comuns de especiarias indianas:",
      "words": [
        "COMINHO",
        "CÚRCUMA",
        "CARDAMOMO",
        "PIMENTA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Para fazer uma margarita é preciso… ",
      "words": [
        "TEQUILA",
        "LARANJA",
        "LIMÃO",
        "SAL"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Uma pessoa livre tem…",
      "words": [
        "AUTONOMIA",
        "INDEPENDÊNCIA",
        "SOBERANIA",
        "INSUBMISSÃO"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "O contrário de Liberdade é… ",
      "words": [
        "PRISÃO",
        "CENSURA",
        "SUBMISSÃO",
        "CÁRCERE"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Lápis de__ ",
      "words": [
        "COR",
        "CERA",
        "CARVÃO",
        "GRAFITE"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Jogos de Tabuleiro:",
      "words": [
        "GAMÃO",
        "DAMAS",
        "WAR",
        "XADREZ"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Tipos de decote: ",
      "words": [
        "V",
        "CANOA",
        "REDONDO",
        "TOMARA QUE CAIA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Música… ",
      "words": [
        "ELETRÔNICA",
        "LENTA",
        "POP",
        "ROCK"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Afluentes do Rio São Francisco: ",
      "words": [
        "VERDE",
        "PARAOPEBA",
        "GRANDE",
        "SALITRE"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Povos Indígenas: ",
      "words": [
        "GUARANI",
        "YANOMAMI",
        "XINGU",
        "TUPI"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Elementos presentes na Capoeira: ",
      "words": [
        "MÚSICA",
        "MOVIMENTO",
        "RODA",
        "GINGA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Instrumentos musicais usados tipicamente no Brasil: ",
      "words": [
        "BERIMBAU",
        "CAVAQUINHO",
        "PANDEIRO",
        "AFOXÉ"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Nomes próprio de origem grega: ",
      "words": [
        "ALEXANDRE",
        "SOFIA",
        "HELENA",
        "LEONIDAS"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Comunidades situadas no Rio de Janeiro:",
      "words": [
        "VIDIGAL",
        "ROCINHA",
        "MANGUEIRA",
        "STA. MARTA"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Escolas de samba:",
      "words": [
        "VAI-VAI",
        "GAVIÕES DA FIEL",
        "ÁGUIA DE OURO",
        "MANCHA VERDE"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Times de futebol:",
      "words": [
        "FLAMENGO",
        "PALMEIRAS",
        "SÃO PAULO",
        "CORINTHIANS"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Atletas de Fórmula 1: ",
      "words": [
        "SENNA",
        "HAMILTON",
        "SCHUMACHER",
        "LAUDA"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Papel___",
      "words": [
        "CARTÃO",
        "VEGETAL",
        "A4",
        "SULFITE"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Material Escolar: ",
      "words": [
        "CADERNO",
        "LÁPIS",
        "CANETA",
        "MOCHILA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Classificação de alguém de acordo com sua idade: ",
      "words": [
        "CRIANÇA",
        "ADOLESCENTE",
        "ADULTO",
        "IDOSO"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ],
  [
    {
      "category": "Qualidade da pessoa que julga com neutralidade: ",
      "words": [
        "IMPARCIALIDADE",
        "EQUANIMIDADE",
        "EQUIDADE",
        "ISENÇÃO"
      ],
      "difficulty": 1,
      "imageSrc": ""
    },
    {
      "category": "Reunião de pessoas que fazem parte de uma mesma causa:",
      "words": [
        "FACÇÃO",
        "PARTIDO",
        "SEITA",
        "CLÃ"
      ],
      "difficulty": 2,
      "imageSrc": ""
    },
    {
      "category": "Grupo de pessoas que praticam crimes:",
      "words": [
        "BANDO",
        "QUADRILHA",
        "CORJA",
        "SÚCIA"
      ],
      "difficulty": 3,
      "imageSrc": ""
    },
    {
      "category": "Palavras que expressam coletivos: ",
      "words": [
        "PANAPANÁ",
        "MANADA",
        "REBANHO",
        "RAMALHETE"
      ],
      "difficulty": 4,
      "imageSrc": ""
    }
  ]
]